class FacetShort extends HTMLSelectElement {
  constructor() {
    super();
    this.initMotionInView();
    this.addEventListener('change', this.onSelectChange.bind(this));
  }

  get options() {
    return this.getElementsByTagName('option');
  }

  get fakeSelectElement() {
    return this.previousElementSibling;
  }

  initMotionInView() {
    FoxTheme.Motion.inView(this, this.calcSelectWidth.bind(this), { margin: '200px 0px 200px 0px' });
  }

  calcSelectWidth() {
    const selectStyle = window.getComputedStyle(this);
    const selectedOptionText = this.options[this.selectedIndex].text;

    const textElement = this.createTextElement(selectedOptionText, selectStyle);
    document.body.appendChild(textElement);
    const selectWidth = textElement.offsetWidth;
    textElement.remove();

    this.style.setProperty('--width', `${selectWidth + 22}px`);
  }

  createTextElement(text, style) {
    const textElement = document.createElement('span');
    textElement.style.fontFamily = style.fontFamily;
    textElement.style.fontSize = style.fontSize;
    textElement.style.fontWeight = style.fontWeight;
    textElement.style.visibility = 'hidden';
    textElement.style.position = 'absolute';
    textElement.innerHTML = text;
    return textElement;
  }

  onSelectChange(event) {
    this.calcSelectWidth();
    this.updateFormParams(event);
  }

  updateFormParams(event) {
    const form = this.getClosestFacetForm() || this.getFirstFacetForm();

    if (form) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(form));
      url.searchParams.delete('page');
      form.renderSection(url.toString(), event);
    }
  }

  getClosestFacetForm() {
    return this.closest('form[is="facet-form"]');
  }

  getFirstFacetForm() {
    return document.querySelector('form[is="facet-form"]');
  }
}
customElements.define('facet-short', FacetShort, { extends: 'select' });

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.minRangeInput = this.querySelector('input[type="range"]:first-child');
    this.maxRangeInput = this.querySelector('input[type="range"]:last-child');
    this.minPriceInput = this.querySelector('input[name="filter.v.price.gte"]');
    this.maxPriceInput = this.querySelector('input[name="filter.v.price.lte"]');

    this.minPriceInput.addEventListener('focus', this.minPriceInput.select);
    this.maxPriceInput.addEventListener('focus', this.maxPriceInput.select);
    this.minPriceInput.addEventListener('change', this.handleInputMinChange.bind(this));
    this.maxPriceInput.addEventListener('change', this.handleInputMaxChange.bind(this));

    this.minRangeInput.addEventListener('change', this.handleRangeMinChange.bind(this));
    this.maxRangeInput.addEventListener('change', this.handleRangeMaxChange.bind(this));
    this.minRangeInput.addEventListener('input', this.handleRangeMinInput.bind(this));
    this.maxRangeInput.addEventListener('input', this.handleRangeMaxInput.bind(this));
  }

  handleInputMinChange(event) {
    event.preventDefault();
    event.target.value = Math.max(
      Math.min(parseInt(event.target.value), parseInt(this.maxPriceInput.value || event.target.max) - 1),
      event.target.min
    );
    this.minRangeInput.value = event.target.value;
    this.minRangeInput.parentElement.style.setProperty(
      '--range-min',
      `${(parseInt(this.minRangeInput.value) / parseInt(this.minRangeInput.max)) * 100}%`
    );
  }

  handleInputMaxChange(event) {
    event.preventDefault();
    event.target.value = Math.min(
      Math.max(parseInt(event.target.value), parseInt(this.minPriceInput.value || event.target.min) + 1),
      event.target.max
    );
    this.maxRangeInput.value = event.target.value;
    this.maxRangeInput.parentElement.style.setProperty(
      '--range-max',
      `${(parseInt(this.maxRangeInput.value) / parseInt(this.maxRangeInput.max)) * 100}%`
    );
  }

  handleRangeMinChange(event) {
    event.stopPropagation();
    this.minPriceInput.value = event.target.value;
    this.minPriceInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleRangeMaxChange(event) {
    event.stopPropagation();
    this.maxPriceInput.value = event.target.value;
    this.maxPriceInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleRangeMinInput(event) {
    event.target.value = Math.min(
      parseInt(event.target.value),
      parseInt(this.maxPriceInput.value || event.target.max) - 1
    );
    event.target.parentElement.style.setProperty(
      '--range-min',
      `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
    );
    this.minPriceInput.value = event.target.value;
  }

  handleRangeMaxInput(event) {
    event.target.value = Math.max(
      parseInt(event.target.value),
      parseInt(this.minPriceInput.value || event.target.min) + 1
    );
    event.target.parentElement.style.setProperty(
      '--range-max',
      `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
    );
    this.maxPriceInput.value = event.target.value;
  }
}
customElements.define('price-range', PriceRange);

const FacetUX = {
  SCROLL_MIN: 9,
  SEARCH_MIN: 13,
  CONTAINERS: ['FacetFiltersContainer', 'MobileFacetFiltersContainer', 'DrawerFacetFiltersContainer'],

  normalize(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim();
  },

  injectStyles() {
    if (document.getElementById('facet-ux-styles')) return;
    const style = document.createElement('style');
    style.id = 'facet-ux-styles';
    style.textContent = `
      .facet-scroll-list {
        max-height: min(320px, 45vh);
        overflow-y: auto;
        overscroll-behavior: contain;
        padding: 2px 8px 2px 2px;
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
      }
      .facet-scroll-list::-webkit-scrollbar { width: 6px; }
      .facet-scroll-list::-webkit-scrollbar-thumb { background: rgba(0, 0, 0, 0.3); border-radius: 3px; }
      .facet-search { width: 100%; min-height: 40px; padding: 8px 12px; font-size: 16px; }
      .facet-search-empty { margin: 0; font-size: 14px; }
      .facet-active-count { font-weight: 400; }
    `;
    document.head.appendChild(style);
  },

  // Native theme facets use data-filter/data-index; the custom all-jewelry catalog uses data-catalog-filter.
  GROUP: 'details.facet-accordion-details',
  KEYED: '[data-filter][data-index], [data-catalog-filter]',
  pendingState: null,
  scheduled: false,

  containerSelector(suffix) {
    return this.CONTAINERS.map((id) => `#${id} ${suffix}`).join(', ');
  },

  keyOf(element) {
    return element.dataset.index || element.dataset.catalogFilter || '';
  },

  enhance() {
    this.injectStyles();
    document.querySelectorAll(this.containerSelector(this.GROUP)).forEach((details) => {
      const content = details.querySelector('.accordion-details__content');
      if (!content) return;

      const list = content.querySelector(':scope > ul.grid:not(.swatches)');
      if (list && !list.dataset.facetUx) {
        list.dataset.facetUx = '1';
        const items = list.querySelectorAll(':scope > li');

        if (items.length >= this.SCROLL_MIN) {
          items.forEach((item) => item.classList.remove('show-more-item', 'hidden'));
          const showMore = content.querySelector('show-more-button');
          if (showMore) showMore.remove();
          list.classList.add('facet-scroll-list');

          if (items.length >= this.SEARCH_MIN) {
            const title = (details.querySelector('summary .h6')?.firstChild?.textContent || '').trim();
            const input = document.createElement('input');
            input.type = 'search';
            input.className = 'form-control facet-search';
            input.placeholder = 'Caută...';
            input.autocomplete = 'off';
            input.setAttribute('data-facet-search', '');
            input.setAttribute('aria-label', title ? `Caută în ${title}` : 'Caută');
            content.insertBefore(input, list);

            const empty = document.createElement('p');
            empty.className = 'facet-search-empty text-subtext';
            empty.textContent = 'Niciun rezultat';
            empty.hidden = true;
            list.after(empty);
          }
        }
      }

      this.updateActiveCount(details);
    });
  },

  updateActiveCount(details) {
    const heading = details.querySelector('summary .h6');
    if (!heading) return;
    let badge = heading.querySelector('.facet-active-count');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'facet-active-count';
      heading.insertBefore(badge, heading.querySelector('small'));
    }
    const count = details.querySelectorAll('input[type="checkbox"]:checked').length;
    const text = count ? ` (${count})` : '';
    if (badge.textContent !== text) badge.textContent = text;
  },

  filterList(input) {
    const details = input.closest(this.GROUP) || input.closest('[data-filter]');
    const list = details && details.querySelector('.facet-scroll-list');
    if (!list) return;

    const query = this.normalize(input.value);
    let shown = 0;
    list.querySelectorAll(':scope > li').forEach((item) => {
      const checkbox = item.querySelector('input[type="checkbox"]');
      const label = item.querySelector('.reversed-link__text') || item;
      const match = !query || this.normalize(label.textContent).includes(query) || (checkbox && checkbox.checked);
      item.style.display = match ? '' : 'none';
      if (match) shown += 1;
    });

    const empty = details.querySelector('.facet-search-empty');
    if (empty) empty.hidden = shown > 0;
  },

  findFilter(containerId, index) {
    const container = document.getElementById(containerId);
    if (!container) return null;
    return Array.from(container.querySelectorAll(this.KEYED)).find((element) => this.keyOf(element) === index);
  },

  captureState() {
    const state = [];
    this.CONTAINERS.forEach((containerId) => {
      const container = document.getElementById(containerId);
      if (!container) return;
      container.querySelectorAll(this.KEYED).forEach((element) => {
        const list = element.querySelector('.facet-scroll-list');
        const search = element.querySelector('[data-facet-search]');
        state.push({
          containerId,
          index: this.keyOf(element),
          open: element.tagName === 'DETAILS' ? element.open : null,
          scrollTop: list ? list.scrollTop : 0,
          query: search ? search.value : '',
        });
      });
    });
    return state;
  },

  restoreState(state) {
    this.enhance();
    (state || []).forEach((entry) => {
      const element = this.findFilter(entry.containerId, entry.index);
      if (!element) return;

      if (entry.open !== null && element.tagName === 'DETAILS' && element.open !== entry.open) {
        // Set state without the theme's open/close animation; keep the accordion's internal flag in sync.
        if (entry.open) {
          element.setAttribute('open', '');
        } else {
          element.removeAttribute('open');
        }
        if ('isOpen' in element) element.isOpen = entry.open;
        element.setAttribute('aria-expanded', entry.open ? 'true' : 'false');
      }

      const search = element.querySelector('[data-facet-search]');
      if (search && entry.query) {
        search.value = entry.query;
        this.filterList(search);
      }

      const list = element.querySelector('.facet-scroll-list');
      if (list) list.scrollTop = entry.scrollTop;
    });
  },

  init() {
    document.addEventListener('input', (event) => {
      const input = event.target.closest && event.target.closest('[data-facet-search]');
      if (input) this.filterList(input);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.closest && event.target.closest('[data-facet-search]')) {
        event.preventDefault();
      }
    });
    document.addEventListener('collection:rerendered', () => this.enhance());

    // Remember the panel state at the moment a value is ticked, so a re-render
    // (native facets or the custom catalog) can put it back.
    document.addEventListener(
      'change',
      (event) => {
        if (event.target.closest && event.target.closest(this.GROUP) && !event.target.closest('[data-facet-search]')) {
          this.pendingState = this.captureState();
        }
      },
      true
    );

    // The custom catalog builds and rebuilds its filters asynchronously; enhance whenever they appear.
    const observer = new MutationObserver((mutations) => {
      const touched = mutations.some((mutation) => {
        const node = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return node && node.closest && node.closest(this.CONTAINERS.map((id) => `#${id}`).join(', '));
      });
      if (!touched || this.scheduled) return;
      this.scheduled = true;
      requestAnimationFrame(() => {
        this.scheduled = false;
        this.enhance();
        if (this.pendingState) {
          const state = this.pendingState;
          this.pendingState = null;
          this.restoreState(state);
        }
      });
    });

    const start = () => {
      observer.observe(document.body, { childList: true, subtree: true });
      this.enhance();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  },
};

class FacetForm extends HTMLFormElement {
  constructor() {
    super();

    this.dirty = false;
    this.cachedMap = new Map();
    this.submitTimer = null;
    this.changedFromFilter = false;

    this.addEventListener('change', this.onFormChange);
    this.addEventListener('submit', this.onFormSubmit);
  }

  onFormChange(event) {
    // Typing in a filter search box only narrows the list; it never submits.
    if (event && event.target && event.target.closest && event.target.closest('[data-facet-search]')) return;

    this.dirty = true;
    this.changedFromFilter = !!(event && event.target && event.target.closest && event.target.closest('[data-filter]'));

    // Short pause so several values can be ticked in a row with a single reload.
    clearTimeout(this.submitTimer);
    this.submitTimer = setTimeout(() => {
      this.dispatchEvent(new Event('submit', { cancelable: true }));
    }, 500);
  }

  onFormSubmit(event) {
    event.preventDefault();
    clearTimeout(this.submitTimer);
    if (!this.dirty) return;

    const url = this.buildUrl().toString();
    this.renderSection(url, event);
  }

  buildUrl() {
    const searchParams = new URLSearchParams(new FormData(this));
    const url = new URL(this.action);

    url.search = '';
    searchParams.forEach((value, key) => url.searchParams.append(key, value));

    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((item) => {
      if (url.searchParams.get(item) === '') {
        url.searchParams.delete(item);
      }
    });

    url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this));
    return url;
  }

  updateURLHash(url) {
    const clonedUrl = new URL(url);
    clonedUrl.searchParams.delete('section_id');
    history.replaceState({}, '', clonedUrl.toString());
  }

  beforeRenderSection() {
    const container = document.getElementById('ProductGridContainer');
    const loadings = document.querySelectorAll('[data-facet-loading]');
    const translateY = FoxTheme.config.motionReduced ? 0 : 50;
    const skipScroll = this.changedFromFilter;
    this.changedFromFilter = false;

    FoxTheme.Motion.timeline([[container, { y: translateY, opacity: 0 }, { duration: 0 }]]);

    setTimeout(() => {
      // Ticking a filter keeps the page where it is; sorting and removing chips still scroll to the grid.
      if (!skipScroll) {
        const target = document.querySelector('.collection');
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - 200,
          behavior: FoxTheme.config.motionReduced ? 'auto' : 'smooth',
        });
      }
      if (loadings) {
        loadings.forEach((loading) => {
          loading.classList.add('btn--loading');
        });
      }
    }, 100);
  }

  afterRenderSection() {
    const container = document.getElementById('ProductGridContainer');
    const items = container.querySelectorAll('.product-card');
    const loadings = document.querySelectorAll('[data-facet-loading]');
    const translateY = FoxTheme.config.motionReduced ? 0 : 50;

    FoxTheme.Motion.timeline([
      [container, { y: [translateY, 0], opacity: [0, 1] }],
      [
        items,
        { y: [translateY, 0], opacity: [0, 1], visibility: ['hidden', 'visible'] },
        { duration: 0.5, delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1) },
      ],
    ]);

    if (loadings) {
      loadings.forEach((loading) => {
        loading.classList.remove('btn--loading');
      });
    }

    document.dispatchEvent(new CustomEvent('collection:rerendered'));
  }

  renderSection(url, event) {
    this.cachedMap.has(url) ? this.renderSectionFromCache(url, event) : this.renderSectionFromFetch(url, event);

    if (this.hasAttribute('data-history')) this.updateURLHash(url);

    this.dirty = false;
  }

  renderAll(responseText, event, uiState) {
    this.renderFilters(responseText, event);
    this.renderFiltersActive(responseText);
    this.renderProductGridContainer(responseText);
    this.renderFacetFiltersContainer(responseText);
    this.renderProductCount(responseText);
    this.renderSortBy(responseText);
    this.renderSortByMobile(responseText);

    // Put back open groups, list scroll positions and search text after the re-render.
    FacetUX.restoreState(uiState);

    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, { responseText: responseText });
  }

  renderSectionFromFetch(url, event) {
    this.beforeRenderSection();
    const start = performance.now();

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const execution = performance.now() - start;

        setTimeout(
          () => {
            const uiState = FacetUX.captureState();
            this.renderAll(responseText, event, uiState);
            this.cachedMap.set(url, responseText);

            this.afterRenderSection();
          },
          execution > 250 ? 0 : 250
        );
      });
  }

  renderSectionFromCache(url, event) {
    this.beforeRenderSection();

    setTimeout(() => {
      const responseText = this.cachedMap.get(url);
      const uiState = FacetUX.captureState();
      this.renderAll(responseText, event, uiState);

      this.afterRenderSection();
    }, 250);
  }

  renderFilters(responseText, event) {
    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const facetElements = parsedHTML.querySelectorAll(
      '#FacetFiltersContainer [data-filter], #MobileFacetFiltersContainer [data-filter], #DrawerFacetFiltersContainer [data-filter]'
    );

    const facetElementsFormDom = document.querySelectorAll(
      '#FacetFiltersContainer [data-filter], #MobileFacetFiltersContainer [data-filter], #DrawerFacetFiltersContainer [data-filter]'
    );

    Array.from(facetElementsFormDom).forEach((currentElement) => {
      if (!Array.from(facetElements).some(({ id }) => currentElement.id === id)) {
        currentElement.classList.add('hidden');
      }
    });

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('[data-filter]') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetElements).filter((element) => !matchesIndex(element));

    facetsToRender.forEach((element) => {
      const filter = document.querySelector(`[data-filter][data-index="${element.dataset.index}"]`);
      if (filter !== null) {
        filter.classList.remove('hidden');
        if (filter.tagName === 'DETAILS') {
          filter.querySelector('summary + *').innerHTML = element.querySelector('summary + *').innerHTML;
        } else {
          filter.innerHTML = element.innerHTML;
        }
      }
    });
  }

  renderFiltersActive(responseText) {
    const id = 'FacetFiltersActive';
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderProductGridContainer(responseText) {
    const id = 'ProductGridContainer';
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;

    const layoutSwitcher = document.querySelector('layout-switcher');
    if (layoutSwitcher) layoutSwitcher.onButtonClick(layoutSwitcher.querySelector('.btn--active'));
  }

  renderFacetFiltersContainer(responseText) {
    const id = 'FacetFiltersContainer';
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderProductCount(responseText) {
    const id = 'ProductCount';
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderSortBy(responseText) {
    const id = 'SortByContainer';
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderSortByMobile(responseText) {
    const id = 'SortByContainerMobile';
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }
}
customElements.define('facet-form', FacetForm, { extends: 'form' });
FacetUX.init();

class FacetRemove extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick);
  }

  onClick(event) {
    const form = this.closest('form[is="facet-form"]') || document.querySelector('form[is="facet-form"]');

    if (form) {
      event.preventDefault();

      const url = new URL(this.href);
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(form));
      form.renderSection(url.toString(), event);
    }
  }
}
customElements.define('facet-remove', FacetRemove, { extends: 'a' });

class FacetCount extends HTMLElement {
  constructor() {
    super();
  }

  facetUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.facetUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate,
      this.onFacetUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.facetUpdateUnsubscriber) {
      this.facetUpdateUnsubscriber();
    }
  }

  get itemCount() {
    return parseInt(this.innerText.replace(/\D/g, ''));
  }

  onFacetUpdate(event) {
    const parsedHTML = new DOMParser().parseFromString(event.responseText, 'text/html');
    const facetCount = parsedHTML.querySelector('facet-count');
    this.innerText = facetCount && facetCount.innerHTML;
    this.hidden = this.itemCount === 0;
  }
}
customElements.define('facet-count', FacetCount);

class FacetToggler extends HTMLButtonElement {
  constructor() {
    super();
    this.onClickHandler = this.onClick.bind(this);
  }

  connectedCallback() {
    this.facetEl = document.getElementById('FacetFiltersContainer');
    this.addEventListener('click', this.onClickHandler);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClickHandler);
  }

  onClick(evt) {
    evt.preventDefault();

    if (this.facetEl.classList.contains('xl:block')) {
      this.facetEl.classList.remove('xl:block');
    } else {
      this.facetEl.classList.add('xl:block');
    }
  }
}
customElements.define('facet-toggler', FacetToggler, { extends: 'button' });

class LoadMoreButton extends HTMLButtonElement {
  constructor() {
    super();
    this.onClickHandler = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClickHandler);

    if (this.getAttribute('type') == 'infinite') {
      FoxTheme.Motion.inView(this, this.onClickHandler, { margin: '200px 0px 200px 0px' });
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClickHandler);
  }

  onClick() {
    if (this.classList.contains('btn--loading')) return;
    this.loadingState();

    const url = this.setUrl().toString();

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        this.renderPagination(responseText);
        this.renderProductGridContainer(responseText);
      });
  }

  renderPagination(responseText) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer === null) return;

    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const pagination = productGridContainer.querySelector('.pagination');
    const source = parsedHTML.querySelector('.pagination');

    if (source) {
      pagination.innerHTML = source.innerHTML;
    } else {
      pagination.remove();
    }
  }

  renderProductGridContainer(responseText) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer === null) return;

    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const productList = productGridContainer.querySelector('.products-list');
    const source = parsedHTML.querySelector('.products-list');

    if (source && productList) {
      source.querySelectorAll('.f-column').forEach((item) => {
        productList.appendChild(item);
      });
    }
  }

  setUrl() {
    const url = new URL(this.getAttribute('action'));
    url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this));
    return url;
  }

  loadingState() {
    this.classList.add('pointer-events-none');
    this.classList.add('btn--loading');
  }
}
customElements.define('load-more-button', LoadMoreButton, { extends: 'button' });

class LayoutSwitcher extends HTMLElement {
  constructor() {
    super();
    this.cookieName = 'hypertheme:collection-layout';

    this.initLayoutMode();
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  get buttons() {
    return this.querySelectorAll('button');
  }

  /**
   * @param {event|element} evt
   */
  onButtonClick(evt) {
    const target = evt.currentTarget ? evt.currentTarget : evt;
    this.changeLayout(target, target.dataset.layoutMode);
  }

  initLayoutMode() {
    if (FoxTheme.config.hasLocalStorage) {
      const layoutMode = window.localStorage.getItem(this.cookieName);

      if (layoutMode !== null) {
        const target = this.querySelector(`button[data-layout-mode="${layoutMode}"]`);
        if (target) {
          this.changeLayout(target, layoutMode);
        }
      }
    }
  }

  changeLayout(target, layoutMode) {
    const productGrid = document.getElementById('ProductsList');
    if (!productGrid) return;

    productGrid.dataset.layout = layoutMode;

    const { gridClass, listClass } = productGrid.dataset;
    if ((gridClass || listClass) && gridClass !== listClass) {
      const productCards = productGrid.querySelectorAll('.product-card');
      productCards &&
        productCards.forEach((card) => {
          if ('grid' === layoutMode) {
            listClass && card.classList.remove(listClass);
            gridClass && card.classList.add(gridClass);
          } else {
            gridClass && card.classList.remove(gridClass);
            listClass && card.classList.add(listClass);
          }
        });
    }

    this.buttons.forEach((button) => {
      button.classList.remove('btn--active');
    });
    target.classList.add('btn--active');

    if (FoxTheme.config.hasLocalStorage) {
      window.localStorage.setItem(this.cookieName, layoutMode);
    }
  }
}
customElements.define('layout-switcher', LayoutSwitcher);
